import React, { useEffect, useState } from 'react';

import { StyleSheet } from 'react-native';

import EditScreenInfo from '../components/EditScreenInfo';
import { RootTabScreenProps } from '../types';
import { ScrollView, SafeAreaView, TouchableOpacity, FlatList, Button, Text, View } from 'react-native';

import { log, logerror } from './Common';
import moment from 'moment';

global.docker = "https://www.gmaxiapi.ovh/";
import styles from '../assets/styles/styles';
import SubStatsMinutescounts from './SubStatsMinutescounts.js';
import SubStatsHourlycounts from './SubStatsHourlycounts.js';

export default function MainScreen(this: any, { navigation }: RootTabScreenProps<'Main'>) {

  let [isLoadingStats, setLoadingStats] = useState(false);
  const [stats, setStats] = useState([]);
  const [lastEntries, setLastEntries] = useState([]);
  const [lastCounts, setLastCounts] = useState([]);
  const [s60, sets60] = useState("");
  const [s600, sets600] = useState("");
  const [h1, seth1] = useState("");
  const [h24, seth24] = useState("");
  const [cs60, setcs60] = useState("");
  const [cs600, setcs600] = useState("");
  const [ch1, setch1] = useState("");
  const [ch24, setch24] = useState("");
  const [users, setusers] = useState("");
  const [currentTime, setCurrentTime] = useState("");
  const [intervalId1, setIntervalId1] = useState(null);
  const [intervalId2, setIntervalId2] = useState(null);
  const [lastUsers, SetLastUsers] = useState([]);
  const [lastSqlrequests, SetLastSqlrequests] = useState([]);

  function handleStats(json: []) {
    sets60(json[0].s60);
    sets600(json[0].s600);
    seth1(json[0].h1);
    seth24(json[0].h24);
    setcs60(json[0].cs60);
    setcs600(json[0].cs600);
    setch1(json[0].ch1);
    setch24(json[0].ch24);
    setusers(json[0].users);

    var formattedDate = moment().format("YYYY-MM-DD HH:mm:ss"); // "Monday, August 12th 2019, 5:52:00 pm"

    setCurrentTime(formattedDate);
  }
  async function closes1() {
    if (intervalId1) {
      clearInterval(intervalId1);
      setIntervalId1(null);
      return;
    }
  }
  async function closes2() {
    if (intervalId2) {
      clearInterval(intervalId2);
      setIntervalId2(null);
      return;
    }
  }
  async function closes() {
    closes1();
    closes2();
  }

  async function setInterval1(timeout1: number) {
    console.log('setInterval1! timeout ' + timeout1);
    if (intervalId1) {
      clearInterval(intervalId1);
      setIntervalId1(null);
    }
    const newIntervalId1 = setInterval(() => {
      console.log('getLastEntries!');
      getStats();
    }, timeout1);
    setIntervalId1(newIntervalId1);

  }

  async function setInterval2(timeout2: number) {
    console.log('setInterval2! timeout ' + timeout2);
    if (intervalId2) {
      clearInterval(intervalId2);
      setIntervalId2(null);
    }

    const newIntervalId2 = setInterval(() => {
      console.log('getLastCounts!');
      getLastEntries();
      getLastCounts();
      getLastUserids();
      getLastSqlrequests();
    }, timeout2);
    setIntervalId2(newIntervalId2);

  }

  async function setIntervals(timeout1: number, timeout2: number) {

    setInterval1(timeout1);
    setInterval2(timeout2);

  }

  async function getStats() {
    setLoadingStats(false); // https://www.gmaxiapi.ovh/monitor/statslast
    fetch(global.docker + 'monitor/statslast', {
      method: 'get',
      headers: {
        'Accept': 'application/json, text/plain, */*',  // It can be used to overcome cors errors
        'Content-Type': 'application/json'
      }
    })
      .then((response) => response.json())
      .then((json) => handleStats(json))
      .catch((error) => logerror("HomeScreen getStats", error));
  }

  async function getLastCounts() {
    setLoadingStats(false);
    fetch(global.docker + 'monitor/getlaststat?limit=5', {
      method: 'get',
      headers: {
        'Accept': 'application/json, text/plain, */*',  // It can be used to overcome cors errors
        'Content-Type': 'application/json'
      }
    })
      .then((response) => response.json())
      .then((json) => setLastCounts(json))
      .catch((error) => logerror("HomeScreen getStats", error));
  }

  async function getLastUserids() {
    setLoadingStats(false);
    fetch(global.docker + 'monitor/countusers?limit=5', {
      method: 'get',
      headers: {
        'Accept': 'application/json, text/plain, */*',  // It can be used to overcome cors errors
        'Content-Type': 'application/json'
      }
    })
      .then((response) => response.json())
      .then((json) => SetLastUsers(json))
      .catch((error) => logerror("HomeScreen getStats", error));
  }

  async function getLastSqlrequests() {
    setLoadingStats(false); // https://www.gmaxiapi.ovh/monitor/getlastsql
    fetch(global.docker + 'monitor/getlastsql', {
      method: 'get',
      headers: {
        'Accept': 'application/json, text/plain, */*',  // It can be used to overcome cors errors
        'Content-Type': 'application/json'
      }
    })
      .then((response) => response.json())
      .then((json) => SetLastSqlrequests(json))
      .catch((error) => logerror("HomeScreen getStats", error));
  }

  async function x() {
    setLoadingStats(false);
    fetch(global.docker + 'monitor/countusers?limit=5', {
      method: 'get',
      headers: {
        'Accept': 'application/json, text/plain, */*',  // It can be used to overcome cors errors
        'Content-Type': 'application/json'
      }
    })
      .then((response) => response.json())
      .then((json) => setLastCounts(json))
      .catch((error) => logerror("HomeScreen getStats", error));
  }

  async function getLastEntries() {
    setLoadingStats(false); // https://www.gmaxiapi.ovh/monitor/getxstatlastips
    fetch(global.docker + 'monitor/getxstatlastips', {
      method: 'get',
      headers: {
        'Accept': 'application/json, text/plain, */*',  // It can be used to overcome cors errors
        'Content-Type': 'application/json'
      }
    })
      .then((response) => response.json())
      .then((json) => setLastEntries(json))
      .catch((error) => logerror("HomeScreen getStats", error));
  }

  useEffect(() => {
    getStats();
    getLastEntries();
    getLastCounts();
    getLastUserids();
    getLastSqlrequests();

  }, [])

  function renderTitleLine(item1: string) {
    return (
      <View style={styles.tableRow}>
        <View style={styles.tableColumnRegular0}>
          <Text style={styles.mtext0}>
            {item1}
          </Text>
        </View>
      </View>

    )
  }

  function renderLine(item1: string, item2: string, colored: boolean) {
    let stylespec = styles.tableColumnRegular2;
    if ((item2 != "0") && colored) {
      stylespec = styles.tableColumnRegular2_colored;
    }
    return (
      <View style={styles.tableRow}>
        <View style={styles.tableColumnRegular1}>
          <Text style={styles.mtext1}>
            {item1}
          </Text>
        </View>
        <View style={stylespec}>
          <Text style={styles.mtext1}>
            {item2}
          </Text>
        </View>
      </View>

    )
  }

  function renderLasts() {
    return (
      <View style={styles.table}>
        {renderTitleLine("Last requests")}
        {renderLine("Last minute", s60, true)}
        {renderLine("Last 10 minutes", s600, true)}
        {renderLine("Last hour", h1, true)}
        {renderLine("Last day", h24, false)}
      </View>
    )
  }

  function renderNewUsers() {
    return (
      <View style={styles.table}>
        {renderTitleLine("Users added")}
        {renderLine("Last minute", cs60, true)}
        {renderLine("Last 10 minutes", cs600, true)}
        {renderLine("Last hour", ch1, true)}
        {renderLine("Last day", ch24, false)}
      </View>
    )
  }

  function splitString(txt: string) {
    var sol = txt.split(".");
    var res = 0;
    for (let i = 0; i < sol.length; i++) {
      res = res + parseInt(sol[i]);
    }
    var returnTxt = "";
    if (!isNaN(res)) {
      returnTxt = returnTxt + res
    }
    return (
      returnTxt
    )
  }


  return (
    <SafeAreaView style={styles.container_main}>
      <ScrollView style={styles.container_main}>
        <View style={styles.tableCol}>
          <View style={styles.container}>
            <Text style={styles.title}>Stats {currentTime}</Text>
            <View style={styles.tableRow}>
              <TouchableOpacity style={styles.spaces}
                onPress={() => setIntervals(500, 1000)}   >
                <Text style={styles.text}>
                  Very Fast
                </Text>
              </TouchableOpacity>
              <TouchableOpacity style={styles.spaces}
                onPress={() => setIntervals(1000, 5000)}   >
                <Text style={styles.text}>
                  Fast
                </Text>
              </TouchableOpacity>
              <TouchableOpacity style={styles.spaces}
                onPress={() => setIntervals(5000, 10000)}   >
                <Text style={styles.text}>
                  Slow
                </Text>
              </TouchableOpacity>
              <TouchableOpacity style={styles.spaces}
                onPress={() => setIntervals(10000, 60000)}   >
                <Text style={styles.text}>
                  Very Slow
                </Text>
              </TouchableOpacity>
            </View >
          </View >
          <View style={styles.container}>
            <View style={styles.tableRow}>
              {renderLasts()}
              {renderNewUsers()}
              <SubStatsMinutescounts
                title="Last hour"
                type="2"
                limmins="60"
                w="340"
                h="240"
              />
              <SubStatsMinutescounts
                title="Last 4 hour"
                type="2"
                limmins="240"
                w="340"
                h="240"
              />
            </View >
          </View >
          <View style={styles.container}>
            <View style={styles.tableRow}>
              <SubStatsHourlycounts
                title="Last 24 hours"
                type="2"
                limhour="24"
                w="340"
                h="240"
              />
              <SubStatsHourlycounts
                title="Last 48 hours"
                type="2"
                limhour="72"
                w="340"
                h="240"
              />
              <SubStatsHourlycounts
                title="Last 240 hours"
                type="2"
                limhour="240"
                w="340"
                h="240"
              />
            </View >
          </View >

          <View style={styles.container}>
            <View style={styles.tableRow}>
              <View style={styles.table}>
                <Text style={styles.mtext0}>
                  Last requests {intervalId1}
                </Text>
                <FlatList
                  nestedScrollEnabled={false}
                  data={lastEntries}
                  renderItem={
                    ({ item }) =>
                      <View style={styles.tableRow}>
                        <Text style={styles.tableColumnRegular2}>{item.ref}</Text>
                        <Text style={styles.tableColumnRegular2}>{item.os}</Text>
                        <Text style={styles.tableColumnRegular2}>{splitString(item.title)}</Text>
                        <Text style={styles.tableColumnRegular2}>{item.year}</Text>
                      </View>
                  } />
              </View >

              <View style={styles.table}>
                <View style={styles.tableCol}>
                  <View style={styles.tableRow}>
                    <View style={styles.table}>
                      <Text style={styles.mtext0}>
                        Count per day {intervalId2}
                      </Text>
                      <FlatList
                        nestedScrollEnabled={false}
                        data={lastCounts}
                        renderItem={
                          ({ item }) =>
                            <View style={styles.tableRow}>
                              <Text style={styles.tableColumnRegular2}>{item.ref}</Text>
                              <Text style={styles.tableColumnRegular2}>{item.count}</Text>
                            </View>
                        } />
                    </View >
                    <View style={styles.table}>
                      <Text style={styles.mtext0}>
                        Created users {intervalId2}
                      </Text>
                      <FlatList
                        nestedScrollEnabled={false}
                        data={lastUsers}
                        renderItem={
                          ({ item }) =>
                            <View style={styles.tableRow}>
                              <Text style={styles.tableColumnRegular2}>{item.ref}</Text>
                              <Text style={styles.tableColumnRegular2}>{item.count}</Text>
                            </View>
                        } />
                    </View >
                  </View >
                  <View style={styles.table}>
                    <Text style={styles.mtext0}>
                      Stats SQLREQUESTS {intervalId2}
                    </Text>
                    <FlatList
                      nestedScrollEnabled={false}
                      data={lastSqlrequests}
                      renderItem={
                        ({ item }) =>
                          <View style={styles.tableRow}>
                            <Text style={styles.tableColumnRegular2}>{item.ref}</Text>
                            <Text style={styles.tableColumnRegular2}>{item.count}</Text>
                          </View>
                      } />
                  </View >

                </View >
              </View >

            </View >
          </View >
        </View >

      </ScrollView >
    </SafeAreaView >
  );
}
